import { ActivityLogFilterType } from '../types/filterOptionsType';

export const validSortTypesByTab = {
  all: [
    'CreatedOn',
    'CID',
    'PID',
    'Category',
    'Activity',
    'Id',
    'UserName',
    'AccountCIDPID',
    'Source',
  ],
  callDocuments: [
    'CreatedOn',
    'CID',
    'PID',
    'Activity',
    'ReportFileName',
    'UserName',
    'AccountCIDPID',
    'Source',
  ],
  personAlerts: ['CreatedOn', 'AccountCIDPID', 'PersonAlertId', 'UserName'],
  personRepository: ['CreatedOn', 'AccountCIDPID', 'PersonId', 'UserName'],
  hospitalForm: ['CreatedOn', 'AccountCIDPID', 'SubmissionNumber', 'UserName'],
};

export function sanitizeFilterOptions(
  filterOptions: ActivityLogFilterType,
  selectedTab: keyof typeof validSortTypesByTab | string,
  isExternalUser: boolean,
): ActivityLogFilterType {
  const validSortTypes = validSortTypesByTab.hasOwnProperty(selectedTab)
    ? validSortTypesByTab[selectedTab as keyof typeof validSortTypesByTab]
    : validSortTypesByTab['all'];

  const safeSortType = validSortTypes.includes(filterOptions.sortType)
    ? filterOptions.sortType
    : validSortTypes[0];

  const sanitized: Partial<ActivityLogFilterType> = { ...filterOptions };

  if (isExternalUser) {
    delete sanitized.accountCidPid;
    delete sanitized.docId;
    delete sanitized.type;
    delete sanitized.categoryActivity;
    delete sanitized.personAlertId;
    delete sanitized.personId;
    delete sanitized.userId;
    delete sanitized.personId;
    delete sanitized.submissionNumber;
  }

  if (selectedTab !== 'all') {
    delete sanitized.type;
    delete sanitized.categoryActivity;
  }
  if (selectedTab !== 'callDocuments' && selectedTab !== '') {
    delete sanitized.reportFileName;
  }

  if (selectedTab !== 'personAlerts') {
    delete sanitized.personAlertId;
  }

  if (selectedTab !== 'personRepository') {
    delete sanitized.personId;
  }

  sanitized.sortType = safeSortType;

  if (Array.isArray(sanitized.tabActivity) && sanitized.tabActivity.length > 0) {
    const hasSelectAll = sanitized.tabActivity.some((t: any) => t.value === 0);
    if (!hasSelectAll) {
      sanitized.activity = sanitized.tabActivity
        .map((t: any) => t.label ?? '')
        .filter((label: string) => label !== '')
        .join(', ');
    }
  }
  delete sanitized.tabActivity;

  return sanitized as ActivityLogFilterType;
}
